 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~loyaltytouches-l~07be23da":"default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~loyaltytouches-l~07be23da","default~modules-user-profile-user-profile-module~pages-layout-module":"default~modules-user-profile-user-profile-module~pages-layout-module","modules-user-profile-user-profile-module":"modules-user-profile-user-profile-module","default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~loyaltytouches-l~bce32968":"default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~loyaltytouches-l~bce32968","default~curriculumbuild-curriculumbuild-module~loyaltytouches-loyaltytouches-module~modules-auth-aut~4f2634ad":"default~curriculumbuild-curriculumbuild-module~loyaltytouches-loyaltytouches-module~modules-auth-aut~4f2634ad","default~modules-auth-auth-module~pages-layout-module":"default~modules-auth-auth-module~pages-layout-module","modules-auth-auth-module":"modules-auth-auth-module","pages-layout-module":"pages-layout-module","highlight-js-lib-core":"highlight-js-lib-core","highlight-js-lib-languages-json":"highlight-js-lib-languages-json","highlight-js-lib-languages-scss":"highlight-js-lib-languages-scss","highlight-js-lib-languages-typescript":"highlight-js-lib-languages-typescript","highlight-js-lib-languages-xml":"highlight-js-lib-languages-xml","modules-errors-errors-module":"modules-errors-errors-module","default~accountsettings-accountsettings-module~publish-publish-module":"default~accountsettings-accountsettings-module~publish-publish-module","accountsettings-accountsettings-module":"accountsettings-accountsettings-module","default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~loyaltytouches-l~8bd576d0":"default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~loyaltytouches-l~8bd576d0","default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~modules-wizards-~593f0b6b":"default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~modules-wizards-~593f0b6b","default~internal-users-internal-users-module~sites-sites-module":"default~internal-users-internal-users-module~sites-sites-module","internal-users-internal-users-module":"internal-users-internal-users-module","default~curriculumbuild-curriculumbuild-module~loyaltytouches-loyaltytouches-module~modules-material~29dacd96":"default~curriculumbuild-curriculumbuild-module~loyaltytouches-loyaltytouches-module~modules-material~29dacd96","common":"common","standards-standards-module":"standards-standards-module","publish-publish-module":"publish-publish-module","curriculumbuild-curriculumbuild-module":"curriculumbuild-curriculumbuild-module","default~modules-material-material-module~overview-overview-module~sites-sites-module":"default~modules-material-material-module~overview-overview-module~sites-sites-module","default~loyaltytouches-loyaltytouches-module~sites-sites-module":"default~loyaltytouches-loyaltytouches-module~sites-sites-module","default~reports-reports-module~sites-sites-module":"default~reports-reports-module~sites-sites-module","sites-sites-module":"sites-sites-module","reports-reports-module":"reports-reports-module","loyaltytouches-loyaltytouches-module":"loyaltytouches-loyaltytouches-module","overview-overview-module":"overview-overview-module","modules-material-material-module":"modules-material-material-module","modules-wizards-wizards-module":"modules-wizards-wizards-module","space-usage-space-usage-module":"space-usage-space-usage-module","teamperfomance-teamperfomance-module":"teamperfomance-teamperfomance-module"}[chunkId]||chunkId) + "-es2015." + {"default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~loyaltytouches-l~07be23da":"91e89493cab334fe06cf","default~modules-user-profile-user-profile-module~pages-layout-module":"c6ad0f13b5265809ef3a","modules-user-profile-user-profile-module":"a37a9c4417e0ca7f87b3","default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~loyaltytouches-l~bce32968":"996cc36072de9d182261","default~curriculumbuild-curriculumbuild-module~loyaltytouches-loyaltytouches-module~modules-auth-aut~4f2634ad":"2952d8deda5d8051a23b","default~modules-auth-auth-module~pages-layout-module":"4707b0c448aff340ce8c","modules-auth-auth-module":"196f6963b93b9a820d41","pages-layout-module":"5831b5981baa2aa0b88e","highlight-js-lib-core":"e2aee5da7b57958a8b4b","highlight-js-lib-languages-json":"ce0180637677657664be","highlight-js-lib-languages-scss":"f8994ae25167cfd7004e","highlight-js-lib-languages-typescript":"20838d48ebf831c116ca","highlight-js-lib-languages-xml":"eef8c0038af1f8fa7897","modules-errors-errors-module":"c9e4a3d9ac6f194afbed","default~accountsettings-accountsettings-module~publish-publish-module":"5ec265253eb43007b9e9","accountsettings-accountsettings-module":"285ae319ec9d7e59fbb0","default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~loyaltytouches-l~8bd576d0":"f5f15bfc8fec9a30eace","default~curriculumbuild-curriculumbuild-module~internal-users-internal-users-module~modules-wizards-~593f0b6b":"6fe6f0a08bb7361ad958","default~internal-users-internal-users-module~sites-sites-module":"89e0049757b67f1b11e6","internal-users-internal-users-module":"43db2f775a82f1d698c4","default~curriculumbuild-curriculumbuild-module~loyaltytouches-loyaltytouches-module~modules-material~29dacd96":"130ba823f8befb3048b3","common":"ff774715fe067492272c","standards-standards-module":"804dfcac86ac30f3d194","publish-publish-module":"7d82fe2e72236a949cdd","curriculumbuild-curriculumbuild-module":"1fc58ca33206990e506f","default~modules-material-material-module~overview-overview-module~sites-sites-module":"7eea492e0a0de9181488","default~loyaltytouches-loyaltytouches-module~sites-sites-module":"8f9393d36e0e328453e5","default~reports-reports-module~sites-sites-module":"f654f1533a9fc6e639ac","sites-sites-module":"d60bf926d4b8faf16350","reports-reports-module":"f8387f59b4da33704f66","loyaltytouches-loyaltytouches-module":"5fdcf6917fe016538963","overview-overview-module":"4672979c2de06d740510","modules-material-material-module":"557fec71ae4a64de3c2e","modules-wizards-wizards-module":"c775af8f2dda624f2f88","space-usage-space-usage-module":"f917a4231e4f0d6a93ea","teamperfomance-teamperfomance-module":"7c438e208dd0c77f1818"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
